var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/* eslint-disable camelcase */
var DecodedToken = /** @class */ (function () {
    function DecodedToken(token) {
        var parts = token === null || token === void 0 ? void 0 : token.split('.');
        if (parts) {
            var body = parts[1];
            var decodedString = Buffer.from(body, 'base64').toString('utf8');
            return JSON.parse(decodedString);
        }
        else {
            return {};
        }
    }
    return DecodedToken;
}());
export { DecodedToken };
var DecodedIdToken = /** @class */ (function (_super) {
    __extends(DecodedIdToken, _super);
    function DecodedIdToken() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DecodedIdToken;
}(DecodedToken));
export { DecodedIdToken };
var DecodedAccessToken = /** @class */ (function (_super) {
    __extends(DecodedAccessToken, _super);
    function DecodedAccessToken() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DecodedAccessToken;
}(DecodedToken));
export { DecodedAccessToken };
